import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngrx/store';
import { first } from 'rxjs/operators';
import { UserStoreSelectors, UserStoreState } from '@core-lib/store/user-store';
import { UserRole } from '@core-lib/enums';

@Pipe({
    name: 'hasRole',
    standalone: false
})
export class HasRolePipe implements PipeTransform {
	constructor(private store: Store<UserStoreState.IUserStoreState>) {}

	transform(role: UserRole): boolean {
		let isAllowed: boolean = false;

		this.store
			.select(UserStoreSelectors.selectUserHasRole, { role })
			.pipe(first())
			.subscribe(a => (isAllowed = a));

		return isAllowed;
	}
}
